import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const StaffManagementPage = lazy(() => import('../pages/hr/StaffManagementPage'));
const LeaveManagementPage = lazy(() => import('../pages/hr/LeaveManagementPage'));

const HRRoutes = () => {
  return (
    <Routes>
      <Route path="staff" element={<StaffManagementPage />} />
      <Route path="leaves" element={<LeaveManagementPage />} />
    </Routes>
  );
};

export default HRRoutes;
